module.exports = __webpack_public_path__ + "static/img/3_1_3_5.31054e18.jpg";